module.exports = __webpack_public_path__ + "assets/img/free_17.88f87db4.png";